/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListAffiliateCashFlowsOptions,
  ListAffiliateCashFlowsResponses,
} from '../types/ListAffiliateCashFlows'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Authenticated access. ADMIN can inspect all programs. INTEGRATOR is limited to its own tenant. Other users must be registered referrers and see only their own referrals. Deactivation retains historical reports. Currency EXTERNAL_DEPOSIT and EXTERNAL_WITHDRAW ledger events only. Pending withdrawals and promotional credits are excluded. Amounts are positive native asset units identified by asset_symbol. The date is when the completed movement was recorded in the ledger. Only events at or after the user's referral assignment are included.
 * @summary List a referred user's customer cash flows
 * {@link /v1/affiliate_programs/:program_id/referrals/:user_id/cash_flows}
 */
export function listAffiliateCashFlows<ThrowOnError extends boolean = true>(
  options: Options<ListAffiliateCashFlowsOptions, ThrowOnError>,
): Unwrappable<RequestResult<ListAffiliateCashFlowsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/affiliate_programs/{program_id}/referrals/{user_id}/cash_flows',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListAffiliateCashFlowsResponses, ThrowOnError>>,
  )
}
